import { render, staticRenderFns } from "./IconVk.vue?vue&type=template&id=629f6c53&"
import script from "./IconVk.vue?vue&type=script&lang=js&"
export * from "./IconVk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629f6c53')) {
      api.createRecord('629f6c53', component.options)
    } else {
      api.reload('629f6c53', component.options)
    }
    module.hot.accept("./IconVk.vue?vue&type=template&id=629f6c53&", function () {
      api.rerender('629f6c53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconVk.vue"
export default component.exports